var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.506,
    height: 12,
    viewBox: "0 0 13.506 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.327,15.708a1.369,1.369,0,0,0,.75,1.221v.187a2.791,2.791,0,0,1-2.406-.845,3.77,3.77,0,0,1-.97.126,3.206,3.206,0,0,1-3.377-3,3.206,3.206,0,0,1,3.377-3,3.206,3.206,0,0,1,3.377,3,2.769,2.769,0,0,1-.626,1.741,1.362,1.362,0,0,0-.125.571ZM8.574,5.143c3.265,0,5.921,2.118,6,4.754A4.6,4.6,0,0,0,12.7,9.5a4.468,4.468,0,0,0-2.98,1.1A3.7,3.7,0,0,0,8.433,13.4a3.6,3.6,0,0,0,.325,1.5l-.184,0a7.414,7.414,0,0,1-.936-.059,5.846,5.846,0,0,1-4.317,1.555v-.316a2.388,2.388,0,0,0,1.5-1.93,2.264,2.264,0,0,0-.025-.336,4.592,4.592,0,0,1-2.226-3.79C2.571,7.326,5.259,5.143,8.574,5.143Z",
    transform: "translate(-2.571 -5.143)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.56315d7ff977ab7fdcc4f1fff3b18393.svg";
export { ForwardRef as ReactComponent };